import { render } from "./RTextarea.vue?vue&type=template&id=536c3c40"
import script from "./RTextarea.vue?vue&type=script&lang=js"
export * from "./RTextarea.vue?vue&type=script&lang=js"

import "./RTextarea.vue?vue&type=style&index=0&id=536c3c40&lang=css"
script.render = render

export default script